import { createSlice } from '@reduxjs/toolkit';
import { setIsLoading } from '../isLoading.slice';
import axios from 'axios';
import { logOut } from '../../../resources/utils';


export const parallelsSlice = createSlice({
    name: 'parallels',
    initialState: {
        items: [],
        item: {},
        message: "",
        error: "",
    },
    reducers: {
        initialStateParallel: (state, action) => {
            return {
                items: [],
                item: {},
                message: "",
                error: "",
            }
        },
        setParallels: (state, action) => {
            return {
                items: action.payload,
                item: {},
                message: "",
                error: "",
            }
        },
        setParallel: (state, action) => {
            return {
                items: [],
                item: action.payload,
                message: "",
                error: "",
            }
        },
        setParallelMessages: (state, action) => {
            return {
                items: [],
                item: {},
                message: action.payload,
                error: "",
            }
        },
        setParallelError: (state, action) => {
            return {
                items: [],
                item: {},
                message: "",
                error: action.payload,
            }
        },
    }
})

export const getParallelsThunk = () => dispatch => {
    dispatch(setIsLoading(true));
    axios.get(`/parallels`)
        .then(res => {
            if (res.status === 200) {
                dispatch(setParallels(res.data))
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setParallelError(res.response?.data))
            }
        })
        .finally(() => dispatch(setIsLoading(false)))
};

export const getParallelThunk = (Parallel_id) => dispatch => {
    dispatch(setIsLoading(true));
    axios.get(`/parallels/${Parallel_id}`)
        .then(res => {
            if (res.status === 200) {
                dispatch(setParallel(res.data))
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setParallelError(res.response?.data))
            }
        })
        .finally(() => dispatch(setIsLoading(false)))
};


export const createParallelThunk = (data) => dispatch => {
    dispatch(setIsLoading(true));
    axios.post(`/parallels/createParallel`, data)
        .then(res => {
            if (res.status === 200) {
                dispatch(setParallelMessages(res.data.data))
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setParallelError(res.response?.data))
            }
        })
        .finally(() => dispatch(setIsLoading(false)))
};


export const updateParallelThunk = (Parallel_id, data) => dispatch => {
    dispatch(setIsLoading(true));
    axios.put(`/parallels/updateParallel/${Parallel_id}`, data)
        .then(res => {
            if (res.status === 200) {
                dispatch(setParallelMessages(res.data.data))
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setParallelError(res.response?.data))
            }
        })
        .finally(() => dispatch(setIsLoading(false)))
};


export const deleteParallelThunk = (Parallel_id) => dispatch => {
    dispatch(setIsLoading(true));
    axios.delete(`/parallels/${Parallel_id}`)
        .then(res => {
            if (res.status === 200) {
                dispatch(setParallelMessages(res.data.data))
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setParallelError(res.response?.data))
            }
        })
        .finally(() => dispatch(setIsLoading(false)))
};

export const { 
    initialStateParallel,
    setParallels,
    setParallel,
    setParallelMessages,
    setParallelError
} = parallelsSlice.actions;

export default parallelsSlice.reducer;